import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import type { TableProps } from 'react-data-table-component';
type PaginationChangeRowsPerPage = NonNullable<TableProps<any>['onChangeRowsPerPage']>;

interface ReportDataProps {
    reportData: any
    handlePageChange: PaginationChangeRowsPerPage | undefined
    handlePerRowsChange: PaginationChangeRowsPerPage | undefined
}

const VehicleSoldReport: React.FC<ReportDataProps> = ({ reportData, handlePageChange, handlePerRowsChange }): any => {




    //Custom Style for the data table
    const customStyles = {
        headCells: {
            style: {
                fontSize: "15px",
                fontWeight: "700"
            },
        },
    };

    //Column Declaraion for the data table
    const columns: any = [
        {
            name: <div>Make</div>,
            wrap: true,
            sortable: false,
            keyName: 'makeName',
            selector: (row: { makeName: string }) => `${row.makeName}`,
        },
        {
            name: <div>Model</div>,
            wrap: true,
            sortable: false,
            keyName: 'modelName', // Corrected from 'model' to 'modelName'
            selector: (row: { modelName: string }) => `${row.modelName}`, // Corrected from 'model' to 'modelName'
        },
        {
            name: <div>Variant</div>,
            wrap: true,
            sortable: false,
            keyName: 'variantName',
            selector: (row: { variantName: string }) => `${row.variantName}`,
        },
        {
            name: <div>First Name</div>,
            wrap: true,
            sortable: false,
            keyName: 'firstName',
            selector: (row: { firstName?: string | null }) => row.firstName ?? "",
        },
        {
            name: <div>Last Name</div>,
            wrap: true,
            sortable: false,
            keyName: 'lastName',
            selector: (row: { lastName?: string | null }) => row.lastName ?? "",
        },
        {
            name: <div>Price</div>, 
            keyName: 'price',
            selector: (row: { price: number; }) => row.price,
            sortable: false,
        },
        {
            name: <div>KM Driven</div>,
            keyName: 'kmDriven',
            selector: (row: { kmDriven: number; }) => row.kmDriven,
            sortable: false,
        },
        {
            name: <div>Sold Date</div>, 
            keyName: 'vehicleSoldDate',
            selector: (row: { vehicleSoldDate: string; }) => row.vehicleSoldDate,
            sortable: false,
        },
    ];


    return (<>
        <br></br>
        <DataTable
            columns={columns}
            data={reportData.vehicleSoldData.rows}
            striped={true}
            pagination
            paginationServer
            paginationTotalRows={reportData.count}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            highlightOnHover={true}
            customStyles={customStyles}
        />

    </>)

}
export default VehicleSoldReport